<template>
  <filter-bar
    label="Follow Up Pipeline"
    :filter-text="filterText"
    :reset="resetFilters"
  >
    <template v-slot:leftBar>
      <filter-bar-sort-by store-module="followUpState" @change="reloadRecords"></filter-bar-sort-by>
    </template>

    <filter-item v-if="this.$store.getters.authUser.can_access_all_leads">
      <filter-users
        store-module="followUpState"
        filter-name="followUp"
        @change="usersFilterText = $event; reloadRecords()"
      ></filter-users>
    </filter-item>

    <filter-item>
      <filter-statuses
        store-module="followUpState"
        filter-name="followUp"
        @change="statusesFilterText = $event; reloadRecords()"
        statuses-name="followUpStatusesInView"
      ></filter-statuses>
    </filter-item>

    <filter-item>
      <filter-campaigns
        store-module="followUpState"
        filter-name="followUp"
        @change="campaignsFilterText = $event; reloadRecords()"
      ></filter-campaigns>
    </filter-item>

    <filter-item>
      <filter-temperatures
        store-module="followUpState"
        filter-name="followUp"
        @change="temperaturesFilterText = $event; reloadRecords()"
      ></filter-temperatures>
    </filter-item>

    <filter-item>
      <filter-deal-probability-score
        store-module="followUpState"
        filter-name="followUp"
        @change="dealProbabilityScoreText = $event"
      ></filter-deal-probability-score>
    </filter-item>

    <filter-item>
      <filter-sequences
        store-module="followUpState"
        filter-name="followUp"
        @change="sequencesFilterText = $event; reloadRecords()"
        help-text="Only pertains to automated follow ups"
      ></filter-sequences>
    </filter-item>

    <filter-item>
      <filter-sequence-next-contact
        store-module="followUpState"
        filter-name="followUp"
        @change="pastNextContactFilterText = $event; reloadRecords()"
        help-text="Only pertains to manual follow ups"
      ></filter-sequence-next-contact>
    </filter-item>

    <filter-item>
      <filter-sequence-statuses
        store-module="followUpState"
        filter-name="followUp"
        @change="sequenceStatusFilterText = $event; reloadRecords()"
        help-text="Only pertains to automated follow ups"
      ></filter-sequence-statuses>
    </filter-item>

    <filter-item v-show="activeTab === 'manual'">
      <filter-date-range
        label="Last Contacted"
        store-module="followUpState"
        filter-name="followUp"
        filter-variable="lastContactedDateRange"
        @change="lastContactedDateRangeFilterText = $event; reloadRecords()"
      ></filter-date-range>
    </filter-item>

    <filter-item v-show="activeTab === 'manual'">
      <filter-date-range
        label="Next Follow Up"
        store-module="followUpState"
        filter-name="followUp"
        filter-variable="followUpDateRange"
        @change="followUpDateRangeFilterText = $event; reloadRecords()"
      ></filter-date-range>
    </filter-item>
  </filter-bar>
</template>

<script>
import FilterBarSortBy from "../../../../../components/filter/FilterBarSortBy";
import FilterSequenceNextContact from "../../../../../components/filter/FilterSequenceNextContact";
import FilterDateRange from "../../../../../components/filter/FilterDateRange.vue";

export default {
  name: "FollowUpFilters",
  components: {FilterDateRange, FilterSequenceNextContact, FilterBarSortBy},
  data() {
    return {
      usersFilterText: null,
      campaignsFilterText: null,
      temperaturesFilterText: null,
      dealProbabilityScoreText: null,
      statusesFilterText: null,
      sequencesFilterText: null,
      sequenceStatusFilterText: null,
      pastNextContactFilterText: null,
      lastContactedDateRangeFilterText: null,
      followUpDateRangeFilterText: null,
      ready: false,
    };
  },
  mounted() {
    // This is to prevent the calling of reloading records before the data i s ready, since there are on change method on the filters.
    this.ready = true;
  },
  computed: {
    filterText() {
      let array = [];

      if (this.usersFilterText) array.push(this.usersFilterText);
      if (this.campaignsFilterText) array.push(this.campaignsFilterText);
      if (this.temperaturesFilterText) array.push(this.temperaturesFilterText);
      if (this.dealProbabilityScoreText) array.push(this.dealProbabilityScoreText);
      if (this.statusesFilterText) array.push(this.statusesFilterText);
      if (this.sequencesFilterText) array.push(this.sequencesFilterText);
      if (this.sequenceStatusFilterText) array.push(this.sequenceStatusFilterText);
      if (this.pastNextContactFilterText) array.push(this.pastNextContactFilterText);
      if (this.lastContactedDateRangeFilterText) array.push(this.lastContactedDateRangeFilterText);
      if (this.followUpDateRangeFilterText) array.push(this.followUpDateRangeFilterText);

      return array.join(" | ");
    },
    activeTab() {
      return this.$store.getters["followUpState/activeTab"];
    }
  },
  methods: {
    reloadRecords() {
      if (this.ready) {
        this.$store.dispatch('followUpState/setup');
      }
    },
    resetFilters() {
      this.usersFilterText = null;
      this.campaignsFilterText = null;
      this.temperaturesFilterText = null;
      this.dealProbabilityScoreText = null;
      this.statusesFilterText = null;
      this.sequencesFilterText = null;
      this.sequenceStatusFilterText = null;
      this.pastNextContactFilterText = null;
      this.lastContactedDateRangeFilterText = null;
      this.followUpDateRangeFilterText = null;

      this.$store.commit("followUpState/resetFilters", "followUp");

      this.reloadRecords()
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../styles/variables/variables";

.filter_bar {
  padding-right: $defaultGap!important;
}
</style>
